import React, { useEffect, useRef } from 'react'
import { debounce } from 'lodash'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Paper } from '@material-ui/core'
import { useDevices } from '@gojiraf/responsive'

const PhoneContainer = ({ children, elevation = 12, ...props }) => {
  const { isDesktop } = useDevices()
  const StyledPhoneContainerRef = useRef(null)
  const inIframe = sessionStorage.getItem('inIframe') === 'true'

  const setWidthBasedOnHeight = debounce(async () => {
    if (StyledPhoneContainerRef.current) {
      StyledPhoneContainerRef.current.style.width =
        (StyledPhoneContainerRef.current.clientHeight * 9) / 16 + 'px'
    }
  }, 100)

  useEffect(() => {
    if (isDesktop) {
      window.addEventListener('resize', setWidthBasedOnHeight)
      return () => {
        window.removeEventListener('resize', setWidthBasedOnHeight)
      }
    }
  }, [isDesktop])

  return (
    <StyledPhoneContainer
      isMobile={!isDesktop}
      inIframe={inIframe}
      ref={StyledPhoneContainerRef}
      component="section"
      height={window.innerHeight}
      elevation={elevation}
      {...props}
    >
      {children}
    </StyledPhoneContainer>
  )
}

const StyledPhoneContainer = styled(Paper)`
  /* Hay dos width y dos height para pisar la primera con la unidad dvh si en el navegador existe, ya que esta es mas consistente para mantener las proporciones */
  width: ${({ isMobile }) => (isMobile ? '100%' : 'calc(87.5vh * 9 / 16)')};
  width: ${({ isMobile }) => (isMobile ? '100%' : 'calc(87.5dvh * 9 / 16)')};
  /* Contención: en desktop las 3 columnas (chat + video + productos) con sus
     márgenes (1rem por lado por card = 6rem) y gaps (2 x 1em = 2rem) nunca
     deben superar el ancho del viewport. El max-height equivalente mantiene
     la proporción 9:16 cuando el cap de ancho entra en juego. */
  max-width: ${({ isMobile }) => (isMobile ? 'none' : 'calc((100vw - 8rem) / 3)')};
  height: ${({ isMobile, height, inIframe }) =>
    inIframe && isMobile ? '100vh' : isMobile ? `${height}px` : '87.5vh'};
  height: ${({ isMobile, inIframe }) =>
    inIframe && isMobile ? '100dvh' : isMobile ? `100dvh` : '87.5dvh'};
  max-height: ${({ isMobile }) => (isMobile ? 'none' : 'calc((100vw - 8rem) / 3 * 16 / 9)')};
  margin: ${({ isMobile }) => (isMobile ? '0' : '1rem')};
  border-radius: ${({ isMobile }) => (isMobile ? '0' : '1rem')};
  transition: width 0.3s ease, height 0.3s ease;
  position: relative;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.2);
`

PhoneContainer.propTypes = {
  children: PropTypes.any,
  elevation: PropTypes.number,
}

export { PhoneContainer }
